import { render, staticRenderFns } from "./shop-details.vue?vue&type=template&id=50beba6f&lang=pug"
import script from "./shop-details.vue?vue&type=script&lang=ts"
export * from "./shop-details.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports